import { sendUIInteractionAnalyticsEvent } from '@app/services/analytics/analytics-send-event';
import { isMobile } from '@app/services/isMobile';
import { derived, writable } from 'svelte/store';
export const wordlist = writable({ beforeCount: 0, afterCount: 0, isLazy: true, combinedWords: [], dummyElementsCount: 1 });
export const similarPhrases = writable({
    isLazy: true,
    straight: { beforeCount: 0, afterCount: 0, isLazy: true, combinedWords: [], dummyElementsCount: 1 },
    reverse: { beforeCount: 0, afterCount: 0, isLazy: true, combinedWords: [], dummyElementsCount: 1 }
});
export function setSimilarPhrases(similarPhrasesData, isLazy = false, activeItem) {
    let straightSimilarPhrases = {
        phrases: similarPhrasesData.phrases && similarPhrasesData.phrases.filter(w => !w.reverse) || [],
        success: similarPhrasesData.success,
    };
    let reverseSimilarPhrases = {
        phrases: similarPhrasesData.phrases && similarPhrasesData.phrases.filter(w => w.reverse) || [],
        success: similarPhrasesData.success,
    };
    similarPhrases.update(currentSimilarPhrasesState => ({
        isLazy: false,
        straight: {
            words: straightSimilarPhrases,
            combinedWords: [...([]), ...(straightSimilarPhrases.phrases || [])],
            beforeCount: 0,
            afterCount: straightSimilarPhrases.phrases && straightSimilarPhrases.phrases.length || 0,
            isLazy,
            activeItem,
            currentPosition: undefined,
            dummyElementsCount: currentSimilarPhrasesState.straight.dummyElementsCount,
        },
        reverse: {
            words: reverseSimilarPhrases,
            combinedWords: [...([]), ...(reverseSimilarPhrases.phrases || [])],
            beforeCount: 0,
            afterCount: reverseSimilarPhrases.phrases && reverseSimilarPhrases.phrases.length || 0,
            isLazy,
            activeItem,
            currentPosition: undefined,
            dummyElementsCount: currentSimilarPhrasesState.reverse.dummyElementsCount,
        },
    }));
}
export function setWordlist(wordlistData, isLazy = false, activeItem) {
    wordlist.update(currentWordlistState => ({
        words: wordlistData,
        combinedWords: [...(wordlistData.before || []), ...(wordlistData.after || [])],
        beforeCount: wordlistData.before && wordlistData.before.length || 0,
        afterCount: wordlistData.after && wordlistData.after.length || 0,
        isLazy,
        activeItem,
        currentPosition: undefined,
        dummyElementsCount: currentWordlistState.dummyElementsCount,
    }));
}
export function wordlistUpdateActiveItem(delta) {
    wordlist.update(currentWordlistState => {
        if (currentWordlistState.beforeCount + currentWordlistState.afterCount <= 0) {
            return currentWordlistState;
        }
        const mod = currentWordlistState.beforeCount + currentWordlistState.afterCount;
        let activeItem = 0;
        if (Number.isInteger(currentWordlistState.activeItem)) {
            activeItem = (currentWordlistState.activeItem + delta + mod) % mod;
        }
        let currentPosition = currentWordlistState.currentPosition === undefined ? -1 : currentWordlistState.currentPosition;
        currentPosition = Math.min(Math.max(-1, currentPosition + delta), currentWordlistState.combinedWords.length + currentWordlistState.dummyElementsCount);
        return Object.assign(Object.assign({}, currentWordlistState), { activeItem, isLazy: false, currentPosition });
    });
}
export function similarPhrasesUpdateActiveItemForward() {
    similarPhrases.update(currentSimilarPhrasesState => {
        if (currentSimilarPhrasesState.straight.beforeCount + currentSimilarPhrasesState.straight.afterCount
            + currentSimilarPhrasesState.reverse.beforeCount + currentSimilarPhrasesState.reverse.afterCount <= 0) {
            return currentSimilarPhrasesState;
        }
        let currentPositionReverse = currentSimilarPhrasesState.reverse.currentPosition;
        let currentPositionStraight = currentSimilarPhrasesState.straight.currentPosition === undefined ? -1 : currentSimilarPhrasesState.straight.currentPosition;
        let maxStraight = currentSimilarPhrasesState.straight.combinedWords.length + currentSimilarPhrasesState.straight.dummyElementsCount;
        let maxReverse = currentSimilarPhrasesState.reverse.combinedWords.length + currentSimilarPhrasesState.reverse.dummyElementsCount;
        if (currentPositionStraight < maxStraight) {
            currentPositionStraight++;
        }
        if (currentPositionStraight == maxStraight) {
            currentPositionReverse = currentSimilarPhrasesState.reverse.currentPosition === undefined ? 1 :
                Math.min(currentSimilarPhrasesState.reverse.currentPosition + 1, maxReverse);
        }
        return {
            straight: Object.assign(Object.assign({}, currentSimilarPhrasesState.straight), { isLazy: false, currentPosition: currentPositionStraight }),
            reverse: Object.assign(Object.assign({}, currentSimilarPhrasesState.reverse), { isLazy: false, currentPosition: currentPositionReverse }),
        };
    });
}
export function similarPhrasesUpdateActiveItemBackward() {
    similarPhrases.update(currentSimilarPhrasesState => {
        if (currentSimilarPhrasesState.straight.beforeCount + currentSimilarPhrasesState.straight.afterCount
            + currentSimilarPhrasesState.reverse.beforeCount + currentSimilarPhrasesState.reverse.afterCount <= 0) {
            return currentSimilarPhrasesState;
        }
        let currentPositionReverse = currentSimilarPhrasesState.reverse.currentPosition;
        let currentPositionStraight = currentSimilarPhrasesState.straight.currentPosition === undefined ? -1 : currentSimilarPhrasesState.straight.currentPosition;
        let maxStraight = currentSimilarPhrasesState.straight.combinedWords.length + currentSimilarPhrasesState.straight.dummyElementsCount;
        let maxReverse = currentSimilarPhrasesState.reverse.combinedWords.length + currentSimilarPhrasesState.reverse.dummyElementsCount;
        if (currentPositionReverse > 0) {
            currentPositionReverse = Math.max(currentPositionReverse - 1, 0);
        }
        if (!currentPositionReverse) {
            currentPositionStraight = Math.max(currentPositionStraight - 1, -1);
        }
        return {
            straight: Object.assign(Object.assign({}, currentSimilarPhrasesState.straight), { isLazy: false, currentPosition: currentPositionStraight }),
            reverse: Object.assign(Object.assign({}, currentSimilarPhrasesState.reverse), { isLazy: false, currentPosition: currentPositionReverse }),
        };
    });
}
export function setWordlistDummyElementsCount(dummyElementsCount) {
    wordlist.update(currentWordlistState => (Object.assign(Object.assign({}, currentWordlistState), { dummyElementsCount })));
}
export function setSimilarPhrasesDummyElementsCount(dummyElementsCount) {
    similarPhrases.update(currentWordlistState => ({
        straight: Object.assign(Object.assign({}, currentWordlistState.straight), { dummyElementsCount }),
        reverse: Object.assign(Object.assign({}, currentWordlistState.straight), { dummyElementsCount })
    }));
}
const searchPhraseWritable = writable('');
export const searchPhrase = derived(searchPhraseWritable, (value) => value);
export function setSearchPhrase(newSearchPhrase) {
    searchPhraseWritable.update(currentVal => {
        let newVal = "";
        if (newSearchPhrase) {
            newVal = newSearchPhrase.trim();
        }
        if (newVal !== currentVal) {
            return newVal;
        }
        return currentVal;
    });
}
export const searchWithWordlistWidgetActive = writable(false);
let prevIsActive = false;
searchWithWordlistWidgetActive.subscribe(isActive => {
    if (prevIsActive != isActive) {
        sendUIInteractionAnalyticsEvent({
            action: `show-search-widget-${isMobile() ? 'mobile' : 'desktop'}-${isActive ? "open" : "close"}`,
            label: isActive ? "open" : "close",
        });
    }
    prevIsActive = isActive;
});
export function activateSearchWidget() {
    searchWithWordlistWidgetActive.set(true);
}
export function deactivateSearchWidget() {
    searchWithWordlistWidgetActive.set(false);
}
export const keyboardActive = writable(false);
export function showKeyboard() {
    keyboardActive.update(currentValue => {
        if (!currentValue) {
            sendUIInteractionAnalyticsEvent({
                action: "show-keyboard",
                label: "open",
            });
        }
        return true;
    });
}
export function hideKeyboard() {
    keyboardActive.update(currentValue => {
        if (currentValue) {
            sendUIInteractionAnalyticsEvent({
                action: "show-keyboard",
                label: "close",
            });
        }
        return false;
    });
}
export function toggleKeyboard() {
    keyboardActive.update(active => {
        sendUIInteractionAnalyticsEvent({
            action: "show-keyboard",
            label: !active ? "open" : "close",
        });
        return !active;
    });
}
export const changeDictionaryWidgetActive = writable(false);
export function showChangeDictionaryWidget() {
    changeDictionaryWidgetActive.set(true);
}
export function hideChangeDictionaryWidget() {
    changeDictionaryWidgetActive.set(false);
}
export function toggleChangeDictionaryWidget() {
    changeDictionaryWidgetActive.update(active => !active);
}
export const changeLanguageWidgetState = writable({ open: false });
export function showChangeLanguageWidget(type) {
    changeLanguageWidgetState.set({ open: true, type });
}
export function hideChangeLanguageWidget() {
    changeLanguageWidgetState.set({ open: false, type: undefined });
}
